import { IconServer } from '@tabler/icons';

const icons = { IconServer };

// ==============================|| ESERVICES MENU ITEMS ||============================== //

const eServices = {
    id: 'allEServices',
    type: 'group',
    children: [
        {
            id: 'hostingServices',
            title: 'Prieglobos paslaugos',
            type: 'collapse',
            icon: icons.IconServer,

            children: [
                {
                    id: 'eServices',
                    title: 'Elektroninės paslaugos',
                    type: 'collapse',

                    children: [
                        {
                            id: 'eMail',
                            title: 'Elektroninis paštas',
                            type: 'item',
                            url: '/prieglobos-paslaugos/e-paslaugos/pastas'
                        },
                        {
                            id: 'webServices',
                            title: 'Tinklapių priegloba',
                            type: 'item',
                            url: '/prieglobos-paslaugos/e-paslaugos/tinklapiu-priegloba'
                        },
                        {
                            id: 'bullyBox',
                            title: 'Patyčių dežutės priegloba',
                            type: 'item',
                            url: '/prieglobos-paslaugos/e-paslaugos/patyciu-dezutes-priegloba'
                        }
                    ]
                },
                {
                    id: 'infrastructureServices',
                    title: 'Infrastruktūros paslaugos',
                    type: 'collapse',

                    children: [
                        {
                            id: 'cloudInfrastructure',
                            title: 'Debesijos infrastruktūros priegloba',
                            type: 'item',
                            url: '/prieglobos-paslaugos/infrastrukturos-paslaugos/debesijos-infrastrukturos-paslaugos'
                        },
                        {
                            id: 'infrastructureRental',
                            title: 'Infrastruktūros nuoma',
                            type: 'item',
                            url: '/prieglobos-paslaugos/infrastrukturos-paslaugos/infrastrukturos-nuoma'
                        },
                        {
                            id: 'backups',
                            title: 'Atsarginių kopijų priegloba',
                            type: 'item',
                            url: '/prieglobos-paslaugos/infrastrukturos-paslaugos/atsarginiu-kopiju-priegloba'
                        },
                        {
                            id: 'docker',
                            title: 'Konteinerių infrastruktūros paslauga',
                            type: 'item',
                            url: '/prieglobos-paslaugos/infrastrukturos-paslaugos/konteineriu-infrastrukturos-paslauga'
                        }
                    ]
                },
                {
                    id: 'identity',
                    title: 'E. tapatybių paslaugos',
                    type: 'collapse',

                    children: [
                        {
                            id: 'sso',
                            title: 'Vieningo prisijungimo priegloba',
                            type: 'item',
                            url: '/prieglobos-paslaugos/e-tapatybiu-paslaugos/vieningo-prisijungimo-paslauga'
                        },
                        {
                            id: 'eIdentity',
                            title: 'E. tapatybių valdymas',
                            type: 'item',
                            url: '/prieglobos-paslaugos/e-tapatybiu-paslaugos/e-tapatybiu-valdymas'
                        }
                    ]
                }
            ]
        }
        // {
        //     id: 'eServices',
        //     title: 'E. paslaugos',
        //     type: 'collapse',
        //     icon: icons.IconServer,

        //     children: [
        //         {
        //             id: 'webServices',
        //             title: 'Web Paslaugos',
        //             type: 'collapse',
        //             children: [
        //                 {
        //                     id: 'orgsWithService',
        //                     title: 'Organizacijos turinčios paslaugą',
        //                     type: 'item',
        //                     url: '/e-paslaugos/web-paslauga/organizacijos'
        //                 },
        //                 {
        //                     id: 'allWebs',
        //                     title: 'Visi web',
        //                     type: 'item',
        //                     url: '/e-paslaugos/web-paslauga/visi-web'
        //                 }
        //             ]
        //         },
        //         {
        //             id: 'eMail',
        //             title: 'Paštas',
        //             type: 'item',
        //             url: '/e-paslaugos/pastas'
        //         },
        //         {
        //             id: 'identity',
        //             title: 'Tapatybės',
        //             type: 'collapse',
        //             children: [
        //                 {
        //                     id: 'sso',
        //                     title: 'SSO',
        //                     type: 'item',
        //                     url: '/e-paslaugos/tapatybes/sso'
        //                 },
        //                 {
        //                     id: 'federations',
        //                     title: 'Federacijos',
        //                     type: 'item',
        //                     url: '/e-paslaugos/tapatybes/federacijos'
        //                 }
        //             ]
        //         }
        //     ]
        // }
    ]
};

export default eServices;